import { useState } from "react";
import { Box, Button, Group, Modal, Text } from "@mantine/core";

type CaseDetailConfirmDeleteModalProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean | null) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  deleting: boolean;
};

const CaseDetailConfirmDeleteModal = (
  props: CaseDetailConfirmDeleteModalProps,
) => {
  const [errorMsg, setErrorMsg] = useState<string>("");
  const {
    modalOpened,
    setModalOpened,
    onConfirm,
    deleting,
    title,
    description,
  } = props;

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(null);
      }}
      title={title}
    >
      <Box>
        <Text fw={400} fz={14}>
          {description}
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(null)}>
            Cancel
          </Button>
          <Button
            loading={deleting}
            disabled={deleting}
            onClick={() => onConfirm()}
          >
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};

export default CaseDetailConfirmDeleteModal;
